import './index.scss';
import ApexCharts from 'apexcharts';
import ChartSummarySection from '../commons/chart-summary/index.js';
import React, { Component } from "react";
import Chart from "react-apexcharts";
import moment from 'moment';
import { __ } from '@wordpress/i18n';

function wisdmLDRConvertTime(seconds) {                     
  var seconds = parseInt(seconds, 10)                      
  var hours   = Math.floor(seconds / 3600)                 
  var minutes = Math.floor((seconds - (hours * 3600)) / 60)
  var seconds = seconds - (hours * 3600) - (minutes * 60)  
  if ( !!hours ) {                                         
    if ( !!minutes ) {                                     
      return `${hours}h ${minutes}m ${seconds}s`           
    } else {                                               
      return `${hours}h ${seconds}s`                       
    }                                                      
  }                                                        
  if ( !!minutes ) {                                       
    return `${minutes}m ${seconds}s`                       
  }                                                        
  return `${seconds}s`                                     
}



class TimeSpentOnACourseDonutChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoaded: false,
      error: null,
      series:[],
      options:[],
      reportTypeInUse: wisdm_learndash_reports_front_end_script_time_spent_on_a_course.report_type,
      chart_title:__('Time Spent On A Course', 'learndash-reports-by-wisdmlabs'),
      graph_type:'donut',
      graph_summary:[],
      start_date:moment(new Date(wisdm_ld_reports_common_script_data.start_date)).unix(),
      end_date:moment(new Date(wisdm_ld_reports_common_script_data.end_date)).unix(),
      help_text:__('This Report displays the time spent by the learners on each Course.','learndash-reports-by-wisdmlabs'),
    };

    this.durationUpdated        = this.durationUpdated.bind(this);
    this.applyFilters           = this.applyFilters.bind(this);
    this.handleReportTypeChange = this.handleReportTypeChange.bind(this);
  }

  isValidGraphData() {
    if (undefined==this.state.options || 0==this.state.options.length) {
      return false;
    } 
    if (undefined==this.state.series || 0==this.state.series.length) {
      return false;
    }
    
    return true;
  }

  updateChart(requestUrl) {
    this.setState({isLoaded:false, error:null});
    wp.apiFetch({
        path: requestUrl, //Replace with the correct API 
     }).then(response => {
          this.plotChartTypeBy(response);
        }).catch((error) => {
          this.setState({
            error:error,
              graph_summary:[],
            isLoaded: true,
            series:[],
          });
        });
  }

  plotChartTypeBy(response) {
    this.setState({series:[], options:[]});
    if (undefined!=response.courseWiseTime) {
        const time_percent = Object.values( response.courseWiseTime ).map( obj => parseFloat( obj.time ) );
        const courses = Object.values( response.courseWiseTime ).map( obj => obj.course );

        this.plotPieChart(time_percent, courses);
        this.setState(
          {
          isLoaded: true,
          graph_summary: {
            left: [{
                  title : __('AVERAGE TIME SPENT ON THE COURSES', 'learndash-reports-by-wisdmlabs'),
                  value: wisdmLDRConvertTime(response.averageCourseTime),
                },],

            right:[{
                title : __('Total Time Spent: ', 'learndash-reports-by-wisdmlabs'),
                value: wisdmLDRConvertTime(response.courseTotalTime),
              }, 
              {
                title: __('Total Courses: ', 'learndash-reports-by-wisdmlabs'),
                value:response.courseCount,
              }],
          },
        }); 
    } else if(undefined!=response.time_spent) {
        const time_spent = Object.values( response.time_spent ).map( obj => parseFloat( obj.time ) );
        const users = Object.values( response.time_spent ).map( obj => obj.username );
        this.plotBarChart(users, time_spent, __('Student/Learner', 'learndash-reports-by-wisdmlabs'), __('Time Spent', 'learndash-reports-by-wisdmlabs'))
        this.setState(
          {
          isLoaded: true,
          graph_summary: {
            left: [{
                  title : __('AVERAGE TIME SPENT PER COURSE', 'learndash-reports-by-wisdmlabs'),
                  value: wisdmLDRConvertTime(response.average_time_spent),
                },],
                
            right:[{
                title : __('Total Time Spent: ', 'learndash-reports-by-wisdmlabs'),
                value: wisdmLDRConvertTime(response.total_time),
              }, 
              {
                title: __('Total Learners: ', 'learndash-reports-by-wisdmlabs'),
                value:response.total_learners,
              }],
          },
        });
    }
  }

  plotBarChart(dataX, dataY, nameX, nameY) {
    let chart_options = {
      chart: {
        id: "basic-bar",
        width: dataX.length*75 < 645 ? '100%' : dataX.length*75,
        height: 400,
        zoom:{
          enabled:false,
        },
        toolbar:{
          show:true,
          export: {
            csv: {
              filename: __( 'Time Spent.csv', 'learndash-reports-by-wisdmlabs' ),
              columnDelimiter: ',',
              headerCategory: nameX,
              headerValue: nameY,
            },
            svg: {
              filename: undefined,
            },
            png: {
              filename: undefined,
            }
          },
        }
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return wisdmLDRConvertTime( val );
        },
        offsetY: -25,
        style: {
          fontSize: '12px',
          colors: ["#008AD8"]
        }
      },
      plotOptions: {
        bar: {
          borderRadius: 5,
          columnWidth: '30%',
          dataLabels: {
            enabled: true,
            position:'top',
          },
        }
      },
      xaxis: {
        title: {
          text: nameX,
        },
        categories: dataX,
        labels:{
          hideOverlappingLabels: false,
          trim: true,
        },
        tickPlacement: 'on',
        min:1,
      },
      yaxis: {
        max: Math.max.apply(Math, dataY) + Math.max.apply(Math, dataY)/10,
        axisBorder: {
          show: true
        },
        title: {
          text: nameY,
        },
        labels: {
          formatter: function(value) {
            return  wisdmLDRConvertTime(value);
          } 
        }
      },
    }

    this.setState({graph_type:'bar', series:[{name:nameY, data:dataY}], options:chart_options});
  }


  plotPieChart(data, labels, tooltipTextLineOne = __('Time Spent', 'learndash-reports-by-wisdmlabs')) {
    let chart_options = {
      colors:['#5f5f5f'],
      theme: {
        monochrome: {
          enabled: true,
          color:'#008AD8',
          shadeTo: 'dark',
          shadeIntensity: 0.65,
        }
      },
      chart: {
        width: '100%',
        type: 'donut',
        dropShadow: {
          enabled: true,
          color: '#111',
          top: -1,
          left: 3,
          blur: 3,
          opacity: 0.2
        }
      },
      stroke: {
        width: 0,
      },
      
      plotOptions: {
        pie: {
          donut: {
            dataLabels: {
              enabled: true,
            },
            total: {
              show: false,
              showAlways: false,
              label: 'Total',
              fontSize: '22px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 600,
              color: '#373d3f',
              formatter: function (w) {
                return w.globals.seriesTotals.reduce((a, b) => {
                  return a + b
                }, 0)
              }
            }
          }
        }
      },
      labels: labels,
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
        }
      }],
      legend: {
        formatter:function(seriesName, opts) {
          return [seriesName, " - ", wisdmLDRConvertTime(opts.w.globals.series[opts.seriesIndex]), ""]
      }
      },
      tooltip: {
        custom: function({series, seriesIndex, dataPointIndex, w}) {
          return '<div class="wisdm-donut-chart-tooltip"> <div class="tooltip-title"><span>' + w.globals.labels[seriesIndex] + '</span></div><div class="tooltip-body"> <span>' + tooltipTextLineOne + ': ' + wisdmLDRConvertTime(series[seriesIndex]) + '</span></div></div>';
        },

        y: {
          formatter: function(value, { series, seriesIndex, dataPointIndex, w }) {
            return  wisdmLDRConvertTime(value);
          }
        },
      },
      };
    this.setState({graph_type:'donut',series:data, options:chart_options});
  }

  componentDidMount() {    
    this.updateChart('/rp/v1/time-spent-on-a-course/?start_date=' + this.state.start_date+'&&end_date='+this.state.end_date);
    document.addEventListener('duration_updated', this.durationUpdated);
    document.addEventListener('wisdm-ld-reports-filters-applied', this.applyFilters);
    document.addEventListener('wisdm-ld-reports-report-type-selected', this.handleReportTypeChange);
  }

  componentDidUpdate() {
    jQuery('.time-spent-on-a-course .mixed-chart').prepend(jQuery('.time-spent-on-a-course .apexcharts-toolbar'));
    jQuery( ".wisdm-learndash-reports-time-spent-on-a-course .chart-title .dashicons" ).hover(

      function() {
        var $div = jQuery('<div/>').addClass('wdm-tooltip').css({
            position: 'absolute',
            zIndex: 999,
            display: 'none'
        }).appendTo(jQuery(this));
        $div.text(jQuery(this).attr('data-title'));
        $div.show();
      }, function() {
        jQuery( this ).find( ".wdm-tooltip" ).remove();
      }
    );
  }

  handleReportTypeChange(event) {
    this.setState({reportTypeInUse:event.detail.active_reports_tab});
  }

  applyFilters(event) {
    let start_date = event.detail.start_date;
    let end_date   = event.detail.end_date;
    let category   = event.detail.selected_categories;
    let course     = event.detail.selected_courses;
    let lesson     = event.detail.selected_lessons;
    let topic      = event.detail.selected_topics;
    let learner    = event.detail.selected_learners;
 
    let request_url = '/rp/v1/time-spent-on-a-course/?start_date=' + start_date + '&end_date=' + end_date + '&category=' + category + '&course=' + course + '&lesson=' + lesson + '&topic=' + topic + '&learner=' + learner;

    //Time spent on a course chart should not display for lesson/topic
    if (undefined==topic && undefined==lesson) {
        this.updateChart(request_url);
        this.setState({reportTypeInUse:'default-ld-reports'});
    } else {
        //hide this block.
        this.setState({reportTypeInUse:'default-ld-reports-lesson-topic'});
    }
   
   }

  durationUpdated(event) {
    this.setState({isLoaded: false, start_date:event.detail.startDate, end_date:event.detail.endDate});
    let requestUrl = '/rp/v1/time-spent-on-a-course/';
    if ('duration_updated'==event.type) {
      requestUrl = '/rp/v1/time-spent-on-a-course/?start_date=' + event.detail.startDate + '&&end_date=' + event.detail.endDate;
    } 
    this.updateChart(requestUrl);
  }

  render() {
    let body = <div></div>;
    let data_validation = '';
    if (!this.isValidGraphData()) {
      data_validation = 'invalid-or-empty-data';
    }
    if(''!=this.state.reportTypeInUse && 'default-ld-reports'!=this.state.reportTypeInUse) {
      body = '';
    } else if (!this.state.isLoaded) {
      // yet loading
      body =  <div class="wisdm-learndash-reports-chart-block wisdm-ld-loading">
                <div>{__('Loading...', 'learndash-reports-by-wisdmlabs')}</div>
              </div>
  } else {
    let graph = '';
    if (!this.state.error) {
      graph = <div class="time-spent-on-a-course">
                <Chart options={this.state.options} series={this.state.series} width={this.state.options.chart.width} height={this.state.options.chart.height} type={this.state.graph_type} />
              </div>;
    }
    body =  
    <div class={"wisdm-learndash-reports-chart-block " + data_validation}> 
      <div class="wisdm-learndash-reports-time-spent-on-a-course graph-card-container">
        <div class="chart-header time-spent-on-a-course-chart-header">
            <div class="chart-title">
              <span>{this.state.chart_title}</span>
              <span class="dashicons dashicons-info-outline widm-ld-reports-info" data-title={this.state.help_text}></span>
            </div>
            <ChartSummarySection wrapper_class='chart-summary-time-spent-on-a-course' graph_summary={this.state.graph_summary} error={this.state.error}/>
          </div>
          <div>
            {graph}
          </div>
        </div>
      </div>;
  }
    return (body);
  }
}

document.addEventListener("DOMContentLoaded", function(event) {
    // Your code to run since DOM is loaded and ready

    let elem = document.getElementsByClassName('wisdm-learndash-reports-time-spent-on-a-course');
    if (elem.length>0) {
      ReactDOM.render(React.createElement(TimeSpentOnACourseDonutChart), elem[0]); 
    }
});

